<script setup lang="ts">
    defineProps<{
        tid?: string | number
    }>()
</script>


<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark" style="margin-bottom: 0;">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#AdminNavigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="AdminNavigation">
            <ul class="navbar-nav mr-auto">
                <li v-if="tid" class="nav-item">
                    <a class="navbar-brand" v-sanitizedHref="`/#/admin/organizations/dashboard/${tid}`">Dashboard</a>
                    <a class="navbar-brand" v-sanitizedHref="`/#/admin/organizations/users/active/${tid}`">Users</a>
                    <a class="navbar-brand" v-sanitizedHref="`/#/admin/organizations/workspaces/${tid}`">Workspaces</a>
                    <a class="navbar-brand" v-sanitizedHref="`/#/sharing/admin/activeshares/${tid}`">Shares</a>
                    <a class="navbar-brand" v-sanitizedHref="`/#/admin/integrations/pipelines/dashboard/${tid}`">Integrations</a>
                    <!--<a class="navbar-brand" v-sanitizedHref="`/#/admin/portfolios/${tid}`">Portfolios</a>-->
                </li>
            </ul>
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                        Account
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" href="/#/organizations/users/dashboard">My dashboard</a>
                        <a class="dropdown-item" href="/#/organizations/users/account">Manage your account</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/organizations/sessions/close">Sign out</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>
